import { getDefaultLanguage } from "../actions/ui";
import { LANGUAGE, LOADING, NOTIFICATIONS } from "../constants/ui";

const initialState = {
  loading: false,
  language: getDefaultLanguage(),
  unreadNotifications: 0
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case NOTIFICATIONS:
      return {
        ...state,
        unreadNotifications: action.payload
      }
    default:
      return state;
  }
};

export default uiReducer;
